import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from "recharts";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useEmployeePerformance } from "@/hooks/useDashboard";
import { cn } from "@/lib/utils";

export function EmployeePerformanceCard() {
  const { data, isLoading } = useEmployeePerformance();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Employee Performance</CardTitle>
        <CardDescription>Active vs. completed jobs per technician</CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <Skeleton className="h-56 w-full" />
        ) : !data || data.length === 0 ? (
          <p className="py-8 text-center text-sm text-muted-foreground">
            No employees yet — add technicians in the Employees module.
          </p>
        ) : (
          <>
            <ResponsiveContainer width="100%" height={180}>
              <BarChart data={data} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
                <XAxis
                  dataKey="fullName"
                  tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }}
                  axisLine={false}
                  tickLine={false}
                  interval={0}
                  angle={-15}
                  textAnchor="end"
                  height={40}
                />
                <YAxis
                  allowDecimals={false}
                  tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }}
                  axisLine={false}
                  tickLine={false}
                  width={24}
                />
                <Tooltip
                  contentStyle={{
                    backgroundColor: "hsl(var(--popover))",
                    border: "1px solid hsl(var(--border))",
                    borderRadius: "var(--radius)",
                    fontSize: 12,
                  }}
                />
                <Bar dataKey="activeJobs" name="Active" fill="hsl(var(--primary))" radius={[3, 3, 0, 0]} />
                <Bar dataKey="completedJobs" name="Completed" fill="hsl(var(--success))" radius={[3, 3, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>

            <div className="mt-4 space-y-2">
              {data.map((emp) => (
                <div key={emp.id} className="flex items-center justify-between text-sm">
                  <span className="font-medium">{emp.fullName}</span>
                  <div className="flex items-center gap-3 text-muted-foreground">
                    <span className="font-data">{emp.activeJobs} active</span>
                    <span className="font-data">{emp.completedJobs} done</span>
                    <span
                      className={cn(
                        "rounded-full px-2 py-0.5 text-xs",
                        emp.status === "ACTIVE"
                          ? "bg-success/15 text-success"
                          : "bg-muted text-muted-foreground"
                      )}
                    >
                      {emp.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}
